import { render, staticRenderFns } from "./CheckpointNew.vue?vue&type=template&id=4963b498&scoped=true&"
import script from "./CheckpointNew.vue?vue&type=script&lang=js&"
export * from "./CheckpointNew.vue?vue&type=script&lang=js&"
import style0 from "./CheckpointNew.vue?vue&type=style&index=0&id=4963b498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4963b498",
  null
  
)

export default component.exports